export default __webpack_public_path__ + "static/media/v3Our-services-Stargazing-photo.6c2bf6ee.jpg";